import { useEffect, useMemo } from 'react'
import { homeThunkActions } from 'src/modules/home/home_slice'
import homeSelectors from 'src/modules/home/homeSelectors'
import { useAppDispatch, useAppSelector } from 'src/modules/hooks'
import { VideoObject } from 'src/modules/shared/Types'
import OnDemandVideoList from 'src/view/home/OnDemandVideoList'
import Message from 'src/view/shared/message'
import VideoPlayer from 'src/view/videoPlayer/VideoPlayer'
import { useNavigate, useParams } from 'react-router-dom'

const HomePage = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { id: videoId } = useParams()
  //allVideos is Array<Array<VideoObject>>. Each inner array is for a category.
  const allVideos = useAppSelector(homeSelectors.selectAllVideos)
  const defaultVideoUrl = useAppSelector(homeSelectors.selectDefaultVideoUrl)
  const activeVideo: VideoObject | null = (allVideos && allVideos.flat().find((x) => x.id === videoId)) || null

  const srcObj = useMemo(() => {
    let srcObjInner = { src: '', type: '' }
    if (videoId) {
      if (activeVideo) {
        srcObjInner = activeVideo.src
      } else if (allVideos.length === 6) {
        //This is the case when all categories are loaded, but there is no video with this id.
        navigate('/')
        Message.error('A video with that ID does not exist. Redirecting you to home.')
      }
    } else if (allVideos.length > 0) {
      if (defaultVideoUrl) {
        srcObjInner = { src: defaultVideoUrl, type: 'application/x-mpegURL' }
      } else {
        srcObjInner = { src: "https://d2arg9zixcnu0v.cloudfront.net/prod_abr_vod/videos/45c38aac-e9c1-4154-9ff2-3f2c4a97cd0a-all-1749892331661.smil/playlist.m3u8", type: "application/x-mpegURL" } //If no videoId is provided, play the first video of the first category.
      }
      //srcObj = homeConstants.liveSource
    }
    return srcObjInner
  }, [videoId, activeVideo, allVideos, navigate, defaultVideoUrl])

  useEffect(() => {
    dispatch(homeThunkActions.fetchOnDemandVideos())
  }, [dispatch])

    useEffect(() => {
    dispatch(homeThunkActions.fetchDefaultUrl())
  }, [dispatch])

  return (
    <div style={{ width: '100%' }}>
      <div style={{ width: '80%', margin: '0 auto', aspectRatio: '16/9' }}>
        <VideoPlayer srcObj={srcObj} autoplay controls play />
        <div style={{ width: '100%', marginTop: '20px' }}>{<OnDemandVideoList activeVideo={activeVideo} />}</div>
      </div>
    </div>
  )
}

export default HomePage
